export default __webpack_public_path__ + "static/media/post-img.67d01cc1.jpeg";